import {css} from '@emotion/react'
import normalizeUrl from '@/biz/normalizeUrl.mjs'
import {FileList} from '@/components/File/index.mjs'
import {useAiContext} from './AiContext.mjs'

const cssUserMessage = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    gap: 12,
    marginLeft: 40,
})

const cssUserMessageCompact = css({
    gap: 4,
})

const cssRequest = css({
    backgroundColor: '#eff6ff',
    whiteSpace: 'pre-wrap',
    padding: 12,
    borderRadius: 12,
    userSelect: 'text',

    '&:empty': {
        display: 'none',
    },
})

const cssRequestCompact = css({
    padding: 4,
    borderRadius: 4,
})

export const UserMessage = ({message, ...props}) => {
    const ai = useAiContext()

    const files = message.files.map(f => {
        const {fileId, len: size, originalFileName: name} = f
        const src = normalizeUrl(`/files/${fileId}`)
        return {name, size, src}
    })

    return (
        <div
            css={[cssUserMessage, ai.compactView && cssUserMessageCompact]}
            {...props}
        >
            {0 < files.length && <FileList files={files} />}

            <div css={[cssRequest, ai.compactView && cssRequestCompact]}>
                {message.content}
            </div>
        </div>
    )
}
